import { ApiResult, request, safeRequest } from '@synergy/api';

import { ProductAttribute } from '../models/product-attribute';
import { ProductAttributesList } from '../models/product-attributes-list';

export class ProductDetailAttributeApi {
    constructor(protected baseUrl: string) {}

    public getAttributes(id: number): Promise<ApiResult<ProductAttributesList>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/products/${id}/attributes`),
            response => response.data
        );
    }

    public patchAttributes(id: number, attributes: ProductAttribute[]): Promise<ApiResult<ProductAttributesList>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/products/${id}/attributes`, { attributes }),
            response => response.data
        );
    }
}
